import { render, staticRenderFns } from "./VSubitem.vue?vue&type=template&id=106b57dc&"
import script from "./VSubitem.vue?vue&type=script&lang=js&"
export * from "./VSubitem.vue?vue&type=script&lang=js&"
import style0 from "./VSubitem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports